import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  connect() {
    const targetNode = this.element;
    const config = { childList: true, subtree: true };
    this.observer = new MutationObserver(this.observerCallback.bind(this));
    this.observer.observe(targetNode, config);
    this.resetScroll()
  }

  disconnect() {
    this.observer.disconnect();
  }

  observerCallback(mutationsList, observer) {
    for(let mutation of mutationsList) {
      if (mutation.type == 'childList') {
        this.resetScroll()
      }
    }
  }

  resetScroll() {
    this.element.scrollTop = this.element.scrollHeight - this.element.clientHeight;
  }
}